import { useCallback, useEffect, useState } from 'react';
import './landing.component.scss';
import {
  ButtonGroup,
  Form,
  Navbar,
  TabContainer,
  TabContent,
  TabPane,
} from 'react-bootstrap';

//import { CompactViewMainComponent } from "../../reports/compact-view/compact-view-main.component"
//import { FilterPillsSelectedValuesComponent } from "../../layout/components/filters/components/filter-pills/filter-pills-selected-values.component"

import { ButtonDefault } from '../../../components/buttons/button-default.component';
//import { DotsButtonComponent } from "../../reports/components/dots-button/dots-button.component"
import { AppErrorBoundaryComponent } from '../../../components/error-boundary/app-error-boundary.component';
import { FilterPaneHeaderComponent } from '../../../components/filters/components/filter-pane-header/filter-pane-header.component';
import { FilterPaneTopComponent } from '../../../components/filters/components/filter-pane-header/filter-pane-top.component';
import { FilterPillsSelectedValuesComponent } from '../../../components/filters/components/filter-pills/filter-pills-selected-values.component';
import {
  useAppSingleFilterSelectedLabel,
  useConcatenateFilterSelection,
  useFilterSelectionMemo,
  useFindFilterSelection,
} from '../../../components/filters/hooks/common.hook';
import { FILTER_NAMES } from '../../../components/filters/hooks/filter-names.constants';
import {
  useFilterCompactViewSelection,
  useFilterProductHierSelection,
  useSetFilterCompactViewSelection,
} from '../../../components/filters/hooks/report-filter-selection.hook';

import {
  DRILLTHROUGH_DECOMP_INSIGHTS_MAP,
  DRILLTHROUGH_DECOMP_INSIGHTS_MATCHSTRATEGY_MAP,
  useUpdateDrillthrough,
} from '../../../components/filters/hooks/use-filter-drillthrough-selection.hook';
import {
  ExportButtonComponent,
  ExportButtonDownloader,
} from '../../../components/reports/components/export-button/export-button.component';
import { ShareButtonComponent } from '../../../components/reports/components/share-button/share-button.component';
import { REPORT_NAMES } from '../../../components/reports/constants/report-names.constants';
import { ReportsComponentProps } from '../../../components/reports/interfaces/reports-component-props';
import { LastRunModelComponent } from '../../../components/reports/last-run-model/last-run-model-component';
import { FilterSelectedValue } from '../../../hooks/filters/interfaces/filter-selected-value.interface';
import { useLastAvailableDate } from '../../../hooks/last-available-date/use-last-available-date.hook';
import { IMAGES_REPO } from '../../../static-resources';
import { BodyContentComponent } from '../../layout/components/body-content/body-content.component';
import { BodySectionComponent } from '../../layout/components/body-section/body-section.component';
import { BodyTopBarComponent } from '../../layout/components/body-top-bar/body-top-bar.component';
import useSwitchPanel, {
  useSwitchPar,
  useSwitchShowDetails,
} from '../../layout/hooks/switch-panel.hook';
import { COMPACT_VIEW_LEVELS } from '../components/compact-view/constants/compact-view-levels.constants';
import { getCompactViewSelection } from '../components/compact-view/helpers/get-selection.helper';
import { TreeComponent } from '../components/compact-view/tree/tree.component';
import ChartComponent from '../components/demand-model-chart/chart-component';
import { FullTableViewComponent } from '../components/full-view/full-table-view.component';
import { useProdHierFilterSelection } from '../components/full-view/hooks/use-prod-hier-filter-selection';
import { SalesKpiComponent } from '../components/sales-kpi/sales-kpi.component';

const defaultSortBy = [{ id: 'WEEK', desc: false }];

export const LandingComponent = ({
  filterSelection,
  enabled,
}: ReportsComponentProps) => {
  const [fullViewEnabled, setFullEnabled] = useState(false);
  const [compactViewEnabled, setCompactEnabled] = useState(false);
  const [PDFDownloader, setPDFDownloader] = useState<
    ExportButtonDownloader | undefined
  >(undefined);

  const { show: tabKey, setShow: setTabKey } = useSwitchPar(
    'dm-tab',
    REPORT_NAMES.COMPACT_VIEW,
  );
  useEffect(() => {
    if (tabKey === REPORT_NAMES.FULL_VIEW) {
      setFullEnabled(true && enabled === true);
      setCompactEnabled(false);
    } else {
      setFullEnabled(false);
      setCompactEnabled(true && enabled === true);
    }
  }, [tabKey, enabled]);

  //const [excludeMode, setExcludeMode] = useState(true)
  const { show: excludeMode, setShow: setExcludeMode } = useSwitchPanel(
    'lm',
    true,
  );
  //const { setShow: setRShow } = useSwitchPanel('fp')

  const filterSelectionProductHier = useFilterProductHierSelection();
  const filterSelectionCv = useConcatenateFilterSelection(
    useFilterCompactViewSelection(),
    filterSelectionProductHier,
  );
  const filterSelectionCompactView = useConcatenateFilterSelection(
    filterSelection,
    filterSelectionCv,
  );

  const filterSetSelection = useSetFilterCompactViewSelection();

  const filterSelectionFullview = useProdHierFilterSelection(filterSelection);
  const pillsSelectionFullview = useFindFilterSelection(
    filterSelectionCompactView,
    (i) =>
      i.values.length === 1 &&
      [
        FILTER_NAMES.CATEGORY,
        FILTER_NAMES.BRAND,
        FILTER_NAMES.SUBBRAND,
        FILTER_NAMES.SIZEGROUP,
      ].indexOf(i.id) !== -1,
  );
  // const selectedFilters =     useFindFilterSelection(filterSelectionCompactView,
  //         (i) => [FILTER_NAMES.CATEGORY, FILTER_NAMES.BRAND, FILTER_NAMES.SUBBRAND, FILTER_NAMES.SIZEGROUP, FILTER_NAMES.PPG, FILTER_NAMES.UPC,FILTER_NAMES.SUBPPG].indexOf(i.id) !== -1)

  const filterSelectionExportButton = useProdHierFilterSelection(
    filterSelectionCompactView,
  );

  useEffect(() => {
    if (!enabled) return;
    if (filterSelection && filterSelection.length > 0 && filterSetSelection) {
      //console.log("RESET ALL DRILLDOWN")

      COMPACT_VIEW_LEVELS.forEach((i) => {
        const selection: FilterSelectedValue = getCompactViewSelection(
          i.filterId,
          excludeMode,
          [],
        );
        const setValue = filterSetSelection[i.filterId];
        if (selection && setValue) {
          setValue(selection);
        }
      });
    }
  }, [filterSelection, filterSetSelection, enabled, excludeMode]);

  const reportTitle = useAppSingleFilterSelectedLabel(FILTER_NAMES.MARKET);

  // Show Decomp Insights page
  const { setShow: setShowDecomp } = useSwitchShowDetails('d', false, '/t/i');
  // Returns a function that transform filter selection to the necessary ones for Decomp Insights.
  const updateDrillthroughDecompInsights = useUpdateDrillthrough(
    DRILLTHROUGH_DECOMP_INSIGHTS_MAP,
    DRILLTHROUGH_DECOMP_INSIGHTS_MATCHSTRATEGY_MAP,
  );

  const handleViewDecompInsights = useCallback(async () => {
    if (enabled === true) {
      setShowDecomp(true);
      // Setup filters before jump to Decomp Insights
      updateDrillthroughDecompInsights(filterSelection);
    }
  }, [
    enabled,
    setShowDecomp,
    updateDrillthroughDecompInsights,
    filterSelection,
  ]);
  // Only Market filter is required to know last run date.
  const filterSelectionForLastRun = useFilterSelectionMemo(
    ...useFindFilterSelection(
      filterSelection,
      (i) => i.id === FILTER_NAMES.MARKET,
    ),
  );
  const lastAvailableDate = useLastAvailableDate(filterSelectionForLastRun);

  return (
    <>
      {/* <div className="pills-container px-5 d-flex">
                        <FilterPillsSelectedValuesComponent filterSelection={filterSelectionCv} />
                    </div> */}
      <BodyTopBarComponent>
        <>
          <div className="d-flex top-filter-container dateadjustments">
            <AppErrorBoundaryComponent>
              <FilterPaneTopComponent
                filterSelection={filterSelection}
                lastAvailableDate={lastAvailableDate}
              />
            </AppErrorBoundaryComponent>
            {/* <div className="ps-3">

                            <FilterPaneHeaderComponent filterSelection={filterSelection} filterIds={[FILTER_NAMES.DATEHIER]} />
                        </div> */}
          </div>

          <div className="top-filter-container ms-auto d-flex">
            <div className="ps-3">
              <FilterPaneHeaderComponent
                filterSelection={filterSelection}
                filterIds={[
                  FILTER_NAMES.MEASUREHIER,
                  FILTER_NAMES.PRODUCTHIER,
                  FILTER_NAMES.DATEHIER,
                ]}
              />
            </div>
            <div className="ps-3">
              <ShareButtonComponent filterSelection={filterSelection} />
            </div>
            {/* <div className="ps-3">

                            <ButtonGroup>

                                <ButtonDefault
                                    value="1"
                                    onClick={(e) => setRShow(true)}
                                    id="filter-panel"
                                    size="sm"
                                    variant="">
                                    <img src={IMAGES_REPO.FilterFunnelIcon} alt="Filters" />
                                </ButtonDefault>
                            </ButtonGroup>
                        </div> */}
            <div className="ps-3 d-flex align-items-center">
              {/* <ExportButtonComponent
                                //asNavLink={true}
                                //IconComponent={<img src={IMAGES_REPO.DotsIcon} alt="" className="dropdown-item-img" />}
                                PDFDownloader={PDFDownloader}
                                reportId={REPORT_NAMES.DEMAND_MODEL_CHART}
                                filterSelection={filterSelectionCompactView}
                                filename="IRIS-Demand-Model"
                            /> */}

              <ExportButtonComponent
                reportName={`${REPORT_NAMES.DEMAND_MODEL_CHART},${REPORT_NAMES.FULL_VIEW}`}
                PDFDownloader={PDFDownloader}
                filterSelection={filterSelectionExportButton}
                filename="IRIS-Demand-model"
              />
            </div>
          </div>
        </>
      </BodyTopBarComponent>
      <BodyContentComponent>
        {/* <BodySectionComponent>
                <FilterContainerComponent filters={selectedFilters}/>
                </BodySectionComponent> */}
        {/* <div className="row gy-3 h-100"> */}
        <BodySectionComponent>
          <div className="report-container">
            <div className="d-flex report-title-container">
              <div className="d-block report-title">
                <div className="d-flex">{reportTitle} Demand</div>
                <div className="d-flex sales-kpi-container">
                  <div className="d-flex">
                    <div className="d-lg-flex">
                      <AppErrorBoundaryComponent>
                        <SalesKpiComponent
                          title="Selected Total:"
                          className="sales-kpi-report"
                          reportName={REPORT_NAMES.SALES_KPI}
                          enabled={enabled}
                          filterSelection={filterSelectionCompactView}
                        />
                      </AppErrorBoundaryComponent>
                    </div>
                    <div className="d-lg-flex ps-3">
                      <AppErrorBoundaryComponent>
                        <SalesKpiComponent
                          title="Total:"
                          reportName={REPORT_NAMES.SALES_KPI}
                          enabled={enabled}
                          filterSelection={filterSelection}
                        />
                      </AppErrorBoundaryComponent>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex ms-auto last-run-container">
                <AppErrorBoundaryComponent>
                  <LastRunModelComponent
                    reportName="Demand Model"
                    filterSelection={filterSelectionForLastRun}
                    enabled={enabled}
                  />
                </AppErrorBoundaryComponent>
              </div>
            </div>
            <AppErrorBoundaryComponent>
              <ChartComponent
                reportName={REPORT_NAMES.DEMAND_MODEL_CHART}
                filterSelection={filterSelectionCompactView}
                enabled={enabled}
                defaultSortBy={defaultSortBy}
                setPDFDownloader={setPDFDownloader}
              />
            </AppErrorBoundaryComponent>
          </div>
        </BodySectionComponent>
        <BodySectionComponent>
          <div className="d-flex justify-content-between align-items-center view-decomp-container">
            <div className="d-flex align-items-center view-decomp-label">
              <img
                src={IMAGES_REPO.LineChartUp}
                alt="Decomp Insights"
                className="me-2 decomp-icon"
              />
              <span className="view-decomp-text">View in Decomp Insights</span>
            </div>
            <div className="view-decomp-button">
              <ButtonDefault
                onClick={handleViewDecompInsights}
                className="view-decomp-btn"
              >
                View Decomp Insights
              </ButtonDefault>
            </div>
          </div>
        </BodySectionComponent>
        <BodySectionComponent>
          <Navbar className="p-0">
            <div className="switch-container report-container">
              <Form.Check
                type="switch"
                value={1}
                defaultChecked={excludeMode}
                onChange={(e) => setExcludeMode(e.currentTarget.checked)}
                label="Select All"
              />
            </div>
            {REPORT_NAMES.FULL_VIEW === tabKey && (
              <div className="demand-model-pills-container">
                <FilterPillsSelectedValuesComponent
                  filterSelection={pillsSelectionFullview}
                />
              </div>
            )}
            <div className="ms-lg-auto d-flex">
              <div>
                <ButtonGroup aria-label="">
                  <ButtonDefault
                    className="full-view-btn"
                    variant="sm"
                    active={REPORT_NAMES.FULL_VIEW === tabKey}
                    onClick={() => setTabKey(REPORT_NAMES.FULL_VIEW)}
                  >
                    Table View
                  </ButtonDefault>
                  <ButtonDefault
                    className="compact-view-btn"
                    variant="sm"
                    active={REPORT_NAMES.COMPACT_VIEW === tabKey}
                    onClick={() => setTabKey(REPORT_NAMES.COMPACT_VIEW)}
                  >
                    Compact View
                  </ButtonDefault>
                </ButtonGroup>
              </div>
              <div className="ps-3">
                {/* <ExportButtonComponent
                                    reportId={REPORT_NAMES.FULL_VIEW}
                                    filterSelection={filterSelectionExportButton}
                                    filename="IRIS-Demand-model"
                                /> */}
              </div>
            </div>
          </Navbar>
        </BodySectionComponent>
        <BodySectionComponent>
          <TabContainer defaultActiveKey={tabKey} activeKey={tabKey}>
            <TabContent>
              <TabPane eventKey={REPORT_NAMES.COMPACT_VIEW}>
                <TreeComponent
                  excludeMode={excludeMode}
                  filterSelection={filterSelection}
                  reportName={REPORT_NAMES.COMPACT_VIEW}
                  className="market-compact-view-component"
                  enabled={compactViewEnabled}
                />
              </TabPane>
              <TabPane eventKey={REPORT_NAMES.FULL_VIEW}>
                <FullTableViewComponent
                  filterSelection={filterSelectionFullview}
                  reportName={REPORT_NAMES.FULL_VIEW}
                  totalReportId={REPORT_NAMES.FULL_VIEW_TOTAL}
                  className="market-full-view-component"
                  enabled={fullViewEnabled}
                  excludeMode={excludeMode}
                />
              </TabPane>
            </TabContent>
          </TabContainer>
        </BodySectionComponent>
      </BodyContentComponent>
    </>
  );
};
export default LandingComponent;
